<template>
  <v-container> Sistema de faltantes de Prostasa S.A. de C.V. </v-container>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
